import BaseServiceCrud from './BaseServiceCrud';

export default class UserRoleService extends BaseServiceCrud {
    constructor() {
        super();
        this.path = 'user-role';
    }
    
    getAll(permissions) {
        const param = permissions ? `?permissions=${permissions}` : ''
        const url = `${this.domain}/${this.path}/all` + param
        return this.fetch(url, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getAllForOfficeWorker() {
        const url = `${this.domain}/${this.path}/officeWorker`
        return this.fetch(url, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}